import { Store, Dispatch, Action } from 'redux'
import {
  LOAD_BOARD_POST_EDIT_ACTION_TYPES,
  getLoadBoardPostCounts,
  MARKETPLACE_SETTINGS_EDIT_ACTION_TYPES,
} from 'utils/actions/loadBoardPosts'
import { getShipment } from 'utils/actions/shipment'

interface InternalAction extends Action<string> {
  error: string
  payload: {
    shipment: {}
    requestData: {
      id: number
    }
  }
}

export const loadBoardPosts = (store: Store) => (next: Dispatch) => async (
  action: InternalAction
) => {
  const { type } = action

  if (type === LOAD_BOARD_POST_EDIT_ACTION_TYPES.LOAD_BOARD_POST_EDIT_SUCCESS) {
    if (action.payload.requestData.id) {
      store.dispatch(getShipment(action.payload.requestData.id, undefined, true))
      store.dispatch(getLoadBoardPostCounts(String(action.payload.requestData.id)))
    }
  }

  if (type === MARKETPLACE_SETTINGS_EDIT_ACTION_TYPES.MARKETPLACE_SETTINGS_EDIT_SUCCESS) {
    if (action.payload.requestData.id) {
      store.dispatch(getLoadBoardPostCounts(String(action.payload.requestData.id)))
    }
  }

  return next(action)
}
